import type { FormValues } from '../SamplesOrders.types'

export const getCounterText = (values: FormValues) => {
  const count = values.items.reduce((previous, item) => previous + parseInt(`${item.quantity}`), 0)

  return count > 0 ? `${count} ${count === 1 ? 'item' : 'items'} in cart` : 'No items in cart'
}
